import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { VocabularyService } from '@hosty-app/services';

import { VocabularyStoreEffects } from './vocabulary-store.effects';
import { reducer, vocabularyStoreFeatureKey } from './vocabulary-store.reducers';

export function provideVocabularyStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(vocabularyStoreFeatureKey, reducer),
    provideEffects([VocabularyStoreEffects]),
    VocabularyService,
  ]);
}
